import { render, staticRenderFns } from "./technology.en.vue?vue&type=template&id=22339fe8&"
import script from "./technology.en.vue?vue&type=script&lang=js&"
export * from "./technology.en.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports